// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { ModeType } from 'src/app/enums/mode-type.enum';
import { RegionType } from 'src/app/enums/region-type.enum';

/*
export const environment = {
  production: true,
  accessKeyId: 'AKIARPYXD3RDTCFWWZUZ',
  secretAccessKey: '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',
  parameterSSM: '/TrayLogistics/UI/EnvironmentVariables/Prod',
  mode: ModeType.Prod
};*/

// moved all ssm values to the env files only for Prod & Staging

export const environment = {
  configurationData: [],
  mode: ModeType.Prod,
  production: true,
  US: {
    userPoolId: 'us-east-1_afct0WxYR',
    region: RegionType.USA,
    regionName: 'United States of America',
    clientId: '28lesqfghkeb219i53pflssvcp',
    appClients: [
      {
        id: 'MjhsZXNxZmdoa2ViMjE5aTUzcGZsc3N2Y3A=',
        urlOmni: 'https://identity.api.cbord.com',
        urlTLMiddleware: 'https://api.traylogistics.cbord.com',
      },
    ],
  },
  Aus: {
    userPoolId: 'ap-southeast-2_qLZRRb7Ko',
    region: RegionType.AUS,
    regionName: 'Australia',
    clientId: '',
    appClients: [
      {
        id: 'NDA4OTdzbXIyNWJwdnZuZ2s0MWkzZW4zb24=',
        urlOmni: 'https://au.identity.cbord.com',
        urlTLMiddleware: 'https://au.api.traylogistics.cbord.com',
      },
    ],
  },
  accessKeyId: '',
  secretAccessKey: '',
  parameterSSM: '',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
